import { createSlice } from "@reduxjs/toolkit";

const initialLanguage = localStorage.getItem("language") || "de"; // Default language is 'de'

const languageSlice = createSlice({
  name: "language",
  initialState: { lang: initialLanguage },
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
      localStorage.setItem("language", action.payload); // Persist language
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
